import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import useGetVsic from '../../../common/category/useGetVsic'
import EventEmitter, {
  SHOW_POPUP_NO_INDUSTRY,
} from '../../../helpers/EventEmitter'
import { formatText } from '../../../helpers/value'
import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import { getDefaultVsic, getDefaultVsicLevel1 } from '../helper'

export const DefaultVsicName = ({ isLevel1, isDynamicReport, isOnSticky }) => {
  const { vsics } = useGetVsic(isDynamicReport)
  const { mainVsicId } = useSelector(selectCompanyInfo)

  const [defaultVsic, setDefaultVsic] = useState({})

  useEffect(() => {
    if (vsics.length && mainVsicId) {
      const defaultVsic = isLevel1
        ? getDefaultVsicLevel1(vsics, mainVsicId)
        : getDefaultVsic(vsics, mainVsicId)

      if (isOnSticky && !Object.keys(defaultVsic).length) {
        EventEmitter.dispatch(SHOW_POPUP_NO_INDUSTRY)
      }

      setDefaultVsic(defaultVsic)
    } else if (isOnSticky && !mainVsicId) {
      EventEmitter.dispatch(SHOW_POPUP_NO_INDUSTRY)
    }
  }, [mainVsicId, vsics])

  return formatText(defaultVsic?.name)
}

DefaultVsicName.propTypes = {
  isLevel1: PropTypes.bool,
}

DefaultVsicName.defaultProps = {
  isLevel1: true,
}
